/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.registration = (await import('./pages/RegistrationPage')).RegistrationPage;
    Components.pricingBenefits = (await import('./pages/PricingPageWrapper')).PricingPageWrapper;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  registration: {
    name: 'RegistrationPage',
    componentName: 'RegistrationPage',
    chunk: () => import('./pages/RegistrationPage'),
    get component() {
      return ssr
        ? serverPages.registration
        : currentRouteName === 'RegistrationPage'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.RegistrationPage,
          })),
          );
    },
    path: '/:context?/myaccount/proXtraPricing/registration',
    channel: null,
  },
  pricingBenefits: {
    name: 'PricingPageWrapper',
    componentName: 'PricingPageWrapper',
    chunk: () => import('./pages/PricingPageWrapper'),
    get component() {
      return ssr
        ? serverPages.pricingBenefits
        : currentRouteName === 'PricingPageWrapper'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.PricingPageWrapper,
          })),
          );
    },
    path: '/:context?/myaccount/proXtraPricing',
    channel: null,
  },
});
